import React, { Component} from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import RedSocialInclude from './redsocial'
import MenuInclude from './Menu';
import renderHTML from 'react-render-html';
import Contact from './contact';
import {Navbar, NavItem, Row, Input, Dropdown, Button, Icon} from 'react-materialize';
import $ from 'jquery'

import { 
    LocationGet } from './actions'

class Menu extends Component {

  constructor(props){
    super(props)
    this.state = {
      menu:[],
      select: false,
      links: false,
      options:{
        edge: 'left',
        closeOnClick: false,
        stopPropagation: false,
      },
      optionsli:{
        hover: false,
        closeOnClick: true
      },
      scrollMenuAct: false,
      sticky:false,
      injectMenu:false,
      changeGeo:false,
      defco: 9,
      slug:''
    }
    this.dropBoxInput = React.createRef()
    this.scrollMenuEvent = this.scrollMenuEvent.bind(this)
    this.handleChangeGeo = this.handleChangeGeo.bind(this)
  }

  componentDidMount(){
    this.setState({
      slug: this.props.slug,
      defco: this.props.defCountry
    })
    $( document ).ready(function() {
        $('.logo').hover(function(){
          $('.dropdown-button').click()
        })
        $('.dropdown-content').hover(function(){
          },function(){
            $('.dropdown-button').click()
          }
        )
    })
  }

  componentWillReceiveProps(next_props) {

    if(next_props.slug === 'locations'){
      // console.log(this.state.slug)
      // console.log(this.state.defco)
    }
    
    if(next_props.defCountry !== this.state.defco){
      // this.setState({
      //   defco: this.props.defCountry
      // })
    }

    if(next_props.country.location !== this.state.country){
      this.setState({
        country: next_props.country.location,
        defco: next_props.country.idtag.term_id
      })
      this.setState({
          slug: next_props.slug
        })
      this.setState({
        menu: []
      })
    }

    if(next_props.menus !== this.state.menu){
      if(next_props.menus.length > 0){
        this.setState({
          slug: next_props.slug
        })
        let menudata = next_props.menus.filter((itemdata) => {
          return itemdata.cat === this.state.slug
        })

        let uniqueArray = menudata.filter((obj, pos, arr) => {
            return arr.map(mapObj => mapObj['object_id']).indexOf(obj['object_id']) === pos;
        });

        menudata = uniqueArray.sort(function(a, b){return a.menu_order - b.menu_order})
        this.setState({
          menu: menudata
        })
      }
    }

    if(next_props.slug !== this.state.slug){
      this.setState({
        slug: next_props.slug
      })
      let menudata = next_props.menus.filter((itemdata) => {
        return itemdata.cat === next_props.slug
      })
      let uniqueArray = menudata.filter((obj, pos, arr) => {
          return arr.map(mapObj => mapObj['object_id']).indexOf(obj['object_id']) === pos;
      });

      menudata = uniqueArray.sort(function(a, b){return a.menu_order - b.menu_order})
      this.setState({
        menu: menudata
      })
    }

    

    if(next_props.select !== this.state.select){
      this.setState({
        select:next_props.select
      })
    }

    if(next_props.links !== this.state.links){
      this.setState({
        links:next_props.links
      })
    }

    if(next_props.injectMenu !== this.state.injectMenu){
      this.setState({
        injectMenu:next_props.injectMenu
      })
    }

    if(next_props.scrollMenu === this.props.scrollMenu){
      this.setState({
        scrollMenuAct: this.props.scrollMenu
      })
      
      window.addEventListener('scroll', this.scrollMenuEvent)
    }

    if(next_props.changeGeo !== this.state.changeGeo){
      this.setState({
        changeGeo:next_props.changeGeo
      })
    }
  }

  scrollMenuEvent(event){
    if(!this.state.scrollMenuAct) return null

    const scrolled = window.pageYOffset
    this.element = ReactDOM.findDOMNode(this);
    const sticky = this.element.offsetTop

    if (scrolled > sticky) {
      this.setState({
        sticky: true
      })
    } else {
      this.setState({
        sticky: false
      })
    }
  }

  handleChangeGeo(e){
    this.props.LocationGet(e.target.value);
  }

  render() {
    return (
      <div ref={this.ref}>
        { !this.state.select && !this.state.links && this.state.menu.length > 0 &&
          <div className={(this.state.sticky)?'stick':''}>
            <Navbar right options={this.state.options}>
              <div className="links-rel-mobile">
                <MenuInclude slug='locations' select={true} col={12} scrollMenu={false} changeGeo={true} defCountry={this.state.defco}/>
              </div>
              {
                this.state.menu.map((item, i) => {  
                  return (
                    <li key={i}>
                      { !item.submenu &&
                        <NavItem key={i} href={item.link} className={(item.title === 'Terminos de uso')? 'hide-on-large-only':''}>{renderHTML(item.title)}</NavItem>
                      }
                      { item.submenu &&
                        <Dropdown className="dropboxItem" options={this.state.optionsli} trigger={
                            <Button>{renderHTML(item.title)}<Icon right>arrow_drop_down</Icon><Icon right>arrow_drop_up</Icon></Button>
                          }>
                          <Row>
                          {
                            item.submenu.map((liitem, li) => {  
                              return (
                                <NavItem key={li} href={liitem.link} className={(liitem.title === 'Terminos de uso')? 'hide-on-large-only':''}>
                                  {renderHTML(liitem.title)}
                                </NavItem>
                              )
                            })
                          }
                          </Row>
                        </Dropdown>
                      }
                    </li>
                  )
                })
              }
              <div className="links-rel-mobile">
                <Contact search={false} countryinit={this.state.country}/>
              </div>
              <div className="social-mobile">
                <RedSocialInclude searchMovile={true}/>
              </div>
            </Navbar>
          </div>
        }
        {
          this.state.select  && !this.state.links && this.state.menu.length > 0 && !this.state.changeGeo &&
          <Row>
            <Input s={this.props.col} type='select' defaultValue={this.state.defco}>
              {
                this.state.menu.map((item, i) => {  
                  return (
                    <option key={i} value={item.object_id}>{renderHTML(item.title)}</option>
                  )
                })
              }
            </Input>
          </Row>
        }
        {
          this.state.select  && !this.state.links && this.state.menu.length > 0 && this.state.changeGeo &&
          <Row ref={this.dropBoxInput}>
            <Input s={this.props.col} type='select' defaultValue={this.state.defco} value={this.state.defco} onChange={this.handleChangeGeo}>
              {
                this.state.menu.map((item, i) => { 
                  return (
                    <option key={i} value={item.object_id}>{renderHTML(item.title)}</option>
                  )
                })
              }
            </Input>
          </Row>
        }
        {
          this.state.links  && this.state.menu.length > 0 &&
          <Row>
            {
              this.state.menu.map((item, i) => { 
                return (
                  <a key={i} href={item.link}>{renderHTML(item.title)}</a>
                )
              })
            }
          </Row>
        }
      </div>
    );
  }
}


function mapStateToProps (reducer){
  return {
    menus: reducer.menus,
    country: reducer.country
  }
}

function mapDispathToProps (dispatch){
  return {
    LocationGet: (data) => dispatch(LocationGet(data))
  }
}

export default connect(mapStateToProps, mapDispathToProps)(Menu)



// WEBPACK FOOTER //
// ./src/Menu.js